var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50", width: "50", height: "50" }, props),
    React.createElement("path", { fill: "none", stroke: "#000", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", d: "M29.9 32.5c0-.3 0-.7-.1-1.2 4.3-.4 8.4-1.6 8.4-2.8C35 25.6 41.2 7 27 7l-1-2C10.4 5 15.5 25.5 12 28.6c0 1.6 4 2.2 8.2 2.7 0 .3 0 .6-.1 1.3C18.4 37.2 6.5 35.9 6 45h38c-.5-9.1-12.3-7.8-14.1-12.5z" }),
    React.createElement("path", { fill: "none", stroke: "#000", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", d: "M30.9 34L25 42l-5.8-8M25 42c2.9 0 7.9-1.8 7.9-1.8s.1-4.4.1-4.9M25 42c-2.9 0-7.9-1.8-7.9-1.8s-.1-4.4-.1-4.9" })
  );
});